<template lang="pug">
    v-form.c-form(autocomplete="off" @submit.prevent="submitForm")
        v-layout(raw wrap)
            v-flex(xs12)

                // Instructor Position
                v-text-field(
                    name="position"
                    :label="$t('fields.position')"
                    v-model="user.position"
                    outline
                )

                // Description Body text-area
                froala(
                    v-model="user.information"
                    :tag="'textarea'"
                    :config="config"
                )
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import '~plugins/froala';

    export default {
        data() {
            return {
                config: {
                    events: {
                        'froalaEditor.initialized': function() {},
                    },
                    toolbarButtons: {
                        moreText: {
                            buttons: [
                                'bold',
                                'italic',
                                'fontSize',
                                'underline',
                                'strikeThrough',
                                'textColor',
                                'backgroundColor',
                                'subscript',
                                'superscript',
                                'fontFamily',
                                'inlineClass',
                                'inlineStyle'
                            ]
                        },
                        moreParagraph: {
                            buttons: [
                                'alignLeft',
                                'alignCenter',
                                'formatOLSimple',
                                'alignRight',
                                'alignJustify',
                                'formatOL',
                                'formatUL',
                                'paragraphFormat',
                                'paragraphStyle',
                                'lineHeight',
                                'outdent',
                                'indent',
                                'quote'
                            ]
                        },
                        moreMisc: {
                            buttons: ['undo', 'redo', 'fullscreen']
                        },
                    },
                    toolbarVisibleWithoutSelection: false,
                    quickInsertEnabled: false,
                    heightMax: 500,
                    heightMin: 300,
                    zIndex: 2501,
                    key:
                        'aLF3c1B8B7C4C2F2F2C-7gmokdhdrH-8ekB-16uD1qG-10yiB3B9B6A5C2C4F4H3A2H3=='
                }
            };
        },
        computed: {
            ...mapGetters('auth', ['user'])
        },
        methods: {
            ...mapActions('auth', ['updateUserData']),

            /**
             * Update password on submit
             * @returns {Promise<void>}
             */
            async submitForm() {
                // Validate all fields
                const validation = await this.$validator.validateAll();

                // Check validation pass
                if (!validation) return false;

                await this.updateUserData(this.user);

                return true;
            }
        }
    };
</script>
